<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>批次模块</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: 'batchList' }">批次列表</el-breadcrumb-item>
            <el-breadcrumb-item>批次详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="inputDiv">
      <div>
        批次名称：
        <span>{{ batch.title }}</span>
      </div>
    </div>
    <div class="inputDiv">
      <div class="inputDiv">
        <div>
          总件数：
          <span>{{ batch.total }}</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          工序数量：
          <span>{{ batch.processCount }}</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          单件成本：
          <span>{{ batch.laborcost }}（元）</span>
        </div>
      </div>
      <div class="inputDiv">
        <div>
          人工成本：
          <span>{{ batch.totalLaborcost }}（元）</span>
        </div>
      </div>
    </div>
    <div class="inputDiv">
      <el-button type="primary" class="widthButton" v-if="batch.checkState == 0 && batch.progress != 2"
        @click="dialogDatchShow">修改名称或数量</el-button>
      <el-button type="primary" class="widthButton" v-if="batch.checkState == 0 && batch.progress != 2"
        @click="addProcess">添加工序</el-button>
      <el-button type="primary" class="widthButton" v-if="batch.progress == 0" @click="upload">导入工序</el-button>
      <el-button type="primary" class="widthButton" v-if="batch.checkState == 0 && batch.progress != 2"
        @click="goCheck">确认工序</el-button>
      <el-button type="primary" class="widthButton" v-if="batch.checkState == 0 && batch.progress == 1"
        @click="updatas">批量修改工序</el-button>

      <el-button type="primary" v-if="batch.progress != 0" class="widthButton"
        @click="exportBatchWorkWorkRecord">统计汇总导出</el-button>
    </div>

    <div class="inputDiv">
      <div>
        工序名称：
        <el-input v-model="name" class="inputLeft" style="width: unset;" placeholder="请输入工序名称"></el-input>
      </div>

      <el-button type="primary" class="widthButton" @click="handleCurrentChange(1)">查询</el-button>
      <el-button type="primary" class="widthButton" @click="exportProcess">导出工序</el-button>
    </div>

    <el-table :data="tableData" border style="width: 95%">
      <el-table-column fixed prop="name" label="工序名称"></el-table-column>
      <el-table-column prop="unitSalary" label="单件（元）"></el-table-column>
      <el-table-column prop="total" label="总件数"></el-table-column>
      <el-table-column prop="procedureTotal" label="工序总价（元）"></el-table-column>
      <el-table-column prop="remark" label="备注" width="200"></el-table-column>
      <el-table-column v-if="batch.checkState == 0 && batch.progress != 2" fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button @click="processUpdata(scope.row)" type="text" size="small">修改</el-button>
          <el-button @click="processDelet(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="grid-content" background @current-change="handleCurrentChange"
      layout="total, prev, pager, next" :total="totalCount" :page-size="pageSize"
      :page-count="pageTotal"></el-pagination>
    <div class="inputDiv">
      <el-button type="primary" v-if="batch.progress == 0" class="widthButton" @click="start">开始</el-button>
      <el-button type="primary" v-if="batch.progress == 1" class="widthButton" @click="end">结束</el-button>
      <el-button class="widthButton" @click="goback">取消</el-button>
    </div>
    <!-- 添加工序 -->
    <el-dialog :title="processDialogTitle" :visible.sync="processDialog">
      <el-form :model="processform">
        <el-form-item label="工序名称:">
          <el-input v-model="processform.name"></el-input>
        </el-form-item>
        <el-form-item label="工序单价:">
          <el-input v-model="processform.unitSalary" type="number"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="processform.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="processDialog = false">取 消</el-button>
        <el-button type="primary" @click="processDialogOK">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加工序结束 -->
    <!-- 修改批次 -->
    <el-dialog title="修改批次" :visible.sync="dialogDatch">
      <el-form :model="batchUpdata">
        <el-form-item label="批次名称:">
          <el-input v-model="batchUpdata.title" :disabled="batch.progress == 1"></el-input>
        </el-form-item>
        <el-form-item label="批次总数:">
          <el-input v-model="batchUpdata.total" type="number"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="batchUpdata.remark" :disabled="batch.progress == 1" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogDatch = false">取 消</el-button>
        <el-button type="primary" @click="updataBatch">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改批次结束-->
    <!--批量导入弹框-->
    <el-dialog v-if="updataShow" title="上传工序" :visible.sync="uploadDialog.visible" width="400px">
      <div class="upload-dialog">
        <el-upload ref="upload" :data="uploadDialog.uploadData" :action="uploadDialog.uploadUrl"
          :headers="uploadDialog.headers" :on-success="uploadCallback" :on-preview="handlePreview" :limit="1"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="uploadSubmit"
            icon="el-icon-upload">导入</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传xls/xlsx文件
            <a class="download" :href="downLoadFileUrl" download>下载模板</a>
          </div>
        </el-upload>
      </div>
    </el-dialog>
    <!-- 导入结束 -->

    <!--批量修改弹框-->
    <el-dialog v-if="updataShow" title="修改工序" :visible.sync="updatasDialog.visible" width="400px">
      <div class="upload-dialog">
        <el-upload ref="updatasUpload" :data="updatasDialog.updatasData" :action="updatasDialog.updatasUrl"
          :headers="updatasDialog.headers" :on-success="updatasCallback" :on-preview="handlePreview" :limit="1"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="updatasSubmit"
            icon="el-icon-upload">导入</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传xls/xlsx文件
            <a class="download" :href="downLoadFileUrl" download>下载模板</a>
          </div>
        </el-upload>
      </div>
    </el-dialog>
    <!-- 批量修改结束 -->
  </div>
</template>
<script>
import SERVER_URL from "@/util/seaver";
import {
  processSel,
  processAdd,
  processMod,
  processDel,
  processExport,
  batchMod,
  batchSel,
  batchStart,
  batchCheck,
  batchComplete
} from "@/api/batch";
import {
  workRecordExportBatchWork
} from "@/api/workRecord";
export default {
  data () {
    return {
      downLoadFileUrl: "",
      uploadDialog: {
        visible: false, //是否显示弹出框
        uploadUrl:
          `${SERVER_URL}/process/import?token=` + localStorage.getItem("token"), //上传地址
        headers: {},
        uploadData: {} //上传数据
      },
      updatasDialog: {
        visible: false, //是否显示弹出框
        updatasUrl:
          `${SERVER_URL}/process/updateBats?token=` +
          localStorage.getItem("token"), //上传地址
        headers: {},
        updatasData: {} //上传数据
      },
      batch: {},
      name: "",
      batchUpdata: {},
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0,
      tableData: [],
      processDialog: false,
      processDialogTitle: "",
      processform: {},
      dialogDatch: false,
      updataShow: false
    };
  },

  mounted () {
    this.downLoadFileUrl = `../download/process.xlsx`;
    let name = localStorage.getItem('company_name')
    console.log(name);
    if (name.includes("陕西金翼")) {
      this.downLoadFileUrl = `../download/jyprocess.xlsx`;

      this.uploadDialog = {
        visible: false, //是否显示弹出框
        uploadUrl: `${SERVER_URL}/process/importJY?token=` + localStorage.getItem("token"), //上传地址
        headers: {},
        uploadData: {} //上传数据
      }
      this.updatasDialog = {
        visible: false, //是否显示弹出框
        updatasUrl: `${SERVER_URL}/process/updateBatsJY?token=` + localStorage.getItem("token"), //上传地址
        headers: {},
        updatasData: {} //上传数据
      }
    }
    this.updataShow = true
    console.log(this.uploadDialog);
    console.log(this.updatasDialog);
    this.batch = this.$route.query;
    this.uploadDialog.uploadData = { batchId: this.batch.id };
    this.updatasDialog.updatasData = { batchId: this.batch.id };
    this.getBatchInfo();
    this.$forceUpdate();
  },
  methods: {
    handlePreview (file) {
      console.log(file);
    },
    dialogDatchShow () {
      this.batchUpdata = {
        title: this.batch.title,
        total: this.batch.total,
        remark: this.batch.remark
      };
      this.dialogDatch = true;
    },
    processDelet (row) {
      this.$confirm("是否删除工序“" + row.name + "”, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          processDel({ id: row.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "工序删除成功!"
              });
              this.getBatchInfo();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    processUpdata (row) {
      this.processform = row;
      this.processDialogTitle = "修改工序";
      this.processDialog = true;
    },
    addProcess () {
      this.processform = {
        name: "",
        unitSalary: "",
        remark: ""
      };
      this.processDialogTitle = "新增工序";
      this.processDialog = true;
    },
    processDialogOK () {
      if (!this.processform.id) {
        //添加工序
        const params = {
          enterpriseId: localStorage.getItem("company_id"),
          name: this.processform.name,
          batchId: this.batch.id,
          //processIndex: this.totalCount + 1,
          daySalary: "0",
          unitSalary: this.processform.unitSalary,
          percent: 0.0,
          remark: this.processform.remark
        };
        processAdd(params)
          .then(() => {
            this.$message({
              type: "success",
              message: "工序新增成功!"
            });
            this.processDialog = false;
            this.getBatchInfo();
          })
          .catch();
      } else {
        //修改工序
        const params = {
          id: this.processform.id,
          enterpriseId: this.processform.enterpriseId,
          name: this.processform.name,
          batchId: this.batch.id,
          processIndex: this.processform.processIndex,
          daySalary: this.processform.daySalary,
          unitSalary: this.processform.unitSalary,
          percent: this.processform.percent,
          remark: this.processform.remark
        };
        processMod(params)
          .then(() => {
            this.$message({
              type: "success",
              message: "工序修改成功!"
            });
            this.processDialog = false;
            this.getBatchInfo();
          })
          .catch();
      }
    },
    handleCurrentChange (e) {
      this.pageNum = e;
      this.getProcessSel();
    },
    getProcessSel () {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        batchId: this.batch.id,
        name: this.name,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      processSel(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          this.tableData = [];
          res.gridData.forEach(element => {
            element.procedureTotal = (
              this.batch.total * element.unitSalary
            ).toFixed(4);
            element.total = this.batch.total;
            this.tableData.push(element);
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    updataBatch () {
      const params = {
        id: this.batch.id,
        enterpriseId: this.batch.enterpriseId,
        batchNo: this.batch.batchNo,
        title: this.batchUpdata.title,
        total: this.batchUpdata.total,
        remark: this.batchUpdata.remark
      };
      batchMod(params)
        .then(() => {
          this.$message({
            type: "success",
            message: "批次修改成功!"
          });
          this.getBatchInfo();
          this.dialogDatch = false;
        })
        .catch();
    },
    getBatchInfo () {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        id: this.batch.id
      };
      batchSel(params)
        .then(res => {
          res.gridData.forEach(element => {
            if (element.id == this.batch.id) {
              this.batch = element;
              this.handleCurrentChange(this.pageNum);
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    goback () {
      this.$router.go(-1);
    },
    start () {
      this.$confirm(
        "批次开始后将不能再对其基本信息进行修改, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          batchStart({ id: this.batch.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "开始成功!"
              });
              this.goback();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    upload () {
      this.uploadDialog.visible = true;
    },
    uploadCallback (res) {
      //上传成功回调
      if (res.error === "0") {
        this.uploadDialog.visible = false;
        this.$message({
          message: "上传成功",
          type: "success",
          duration: 5000
        });
        this.getBatchInfo();
      } else {
        this.$message({
          message: res.errMsg,
          type: "error",
          duration: 5000
        });
      }
      this.$refs.upload.clearFiles();
    },

    updatas () {
      this.updatasDialog.visible = true;
    },
    updatasCallback (res) {
      //上传成功回调
      if (res.error === "0") {
        this.updatasDialog.visible = false;
        this.$message({
          message: "上传成功",
          type: "success",
          duration: 5000
        });
        this.getBatchInfo();
      } else {
        this.$message({
          message: res.errMsg,
          type: "error",
          duration: 5000
        });
      }
      this.$refs.updatasUpload.clearFiles();
    },

    goCheck () {
      this.$confirm("批次开始后将不能再对其工序进行修改, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          batchCheck({ id: this.batch.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "确认成功!"
              });
              this.getBatchInfo();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    end () {
      if (this.batch.checkState == 0) {
        this.$message({
          type: "error",
          message: "请先确认工序才能结束！"
        });
        return;
      }
      this.$confirm("批次结束后将不能再上报此批次的工作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          batchComplete({ id: this.batch.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "结束成功!"
              });
              this.goback();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    uploadSubmit () {
      //点击上传
      this.$refs.upload.submit();
    },
    updatasSubmit () {
      //点击上传
      this.$refs.updatasUpload.submit();
    },
    exportProcess () {
      const params = {
        userId: localStorage.getItem("user_id"),
        batchId: this.batch.id
      };
      processExport(params, this.batch.title + "  工序列表");
    },
    exportBatchWorkWorkRecord () {
      const params = {
        userId: localStorage.getItem("user_id"),
        batchId: this.batch.id
      };
      workRecordExportBatchWork(params, this.batch.title + "  汇总表");
    }
  }
};
</script>
